import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateThanksToYouQueries } from "Api/Mutations/Lead/invalidateThanksToYouQueries";
import {
  type SetThanksToYouParticipationCommand,
  type SetThanksToYouParticipationResult,
  putLeadsThanksToYouParticipation,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SetThanksToYouParticipationResult) => void;
  onError?: (error: unknown) => void;
};

/**
 * Records the person's Díky Tobě answer (ZS-1623): the wizard checkbox or joining after a refusal.
 * A refusal cuts the person's referrals and a join opens the invitation link again, so besides
 * user-info (which every reader of the state uses) the affiliate link, the lead lists and the
 * earnings are refetched too.
 */
export const useSetThanksToYouParticipationMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: SetThanksToYouParticipationCommand) =>
        putLeadsThanksToYouParticipation(data),
    ),
    onSuccess: async (result: SetThanksToYouParticipationResult) => {
      onSuccess?.(result);
      await invalidateThanksToYouQueries(queryClient);
    },
    onError,
  });
};
